export default __webpack_public_path__ + "static/media/deskReservationNav.38eb8269.png";